import { render, staticRenderFns } from "./TrainerContestCreate.vue?vue&type=template&id=72b3b93e"
import script from "./TrainerContestCreate.vue?vue&type=script&lang=js"
export * from "./TrainerContestCreate.vue?vue&type=script&lang=js"
import style0 from "./TrainerContestCreate.vue?vue&type=style&index=0&id=72b3b93e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports